export function cutFitsBetween(current, next, cut, hasMore) {
  if (!Number.isFinite(+cut) || !Number.isFinite(+current)) return false;
  return current >= cut && (next ? next < cut : !hasMore);
}

export function cutTimestamp(value) {
  if (!value) return NaN;
  const iso = typeof value === 'string' && !/([Zz]|[+-]\d{2}:?\d{2})$/.test(value)
    ? value.replace(' ', 'T') + 'Z' : value;
  return +new Date(iso);
}

// Collapse only adjacent notices; never cross a receipt, gap or balance divider.
export function groupStatementCuts(items, oldestLoadedAt = null) {
  const result = [];
  for (const item of items) {
    if (item.type !== 'corte') { result.push(item); continue; }
    const timestamp = cutTimestamp(item.fecha);
    if (!Number.isFinite(timestamp) || (oldestLoadedAt !== null && timestamp < oldestLoadedAt)) continue;
    const last = result[result.length - 1];
    if (last?.type === 'cut_group') last.cuts.push(item);
    else result.push({type: 'cut_group', key: item.key, cuts: [item]});
  }
  for (const item of result) {
    if (item.type === 'cut_group') item.cuts.sort((a, b) => cutTimestamp(b.fecha) - cutTimestamp(a.fecha));
  }
  return result;
}
